import api from "../services/api";
import { APIS } from "../endpoints";

export const getAllResearchCategoriesData = async (limit, page, searchTerm) => {
    const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchTerm) {
        formData.append('search', searchTerm); // Add search term
    }

    const params = new URLSearchParams(formData);
    const result = await api.get(`${APIS.BASE_URL}${APIS.researchCategories}`, {
        params: params
    })

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getResearchCategoryData = async (alias) => {
    // Construct the endpoint URL conditionally based on the presence of `section`
    const endpoint = `${APIS.BASE_URL}admin/research-categories/${alias}`;

    try {
        const result = await api.get(endpoint);

        // Return the `data` if the result exists, otherwise return an empty array
        return result?.data?.data || [];
    } catch (error) {
        console.error('Error fetching libraries data:', error);
        return [];
    }
};

export const updateResearchCategoriesData = async (alias, data, deletedValues) => {

    const payload = {
        ...data,
        deletedValues: deletedValues
    };

    const result = await api.put(`${APIS.BASE_URL}admin/research-categories/${alias}`, payload)

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const getResearchCategoriesAPI = async () => {
    const result = await api.get(`${APIS.BASE_URL}${APIS.allResearchCategory}`)
    if (result) {
      return result?.data?.data;
    }
  };

export const getRcTypeSuggestions = async (inputValue) => {
    try {
        const params = new URLSearchParams();
        if (inputValue) {
            params.append('search', inputValue);
        }
        
        const result = await api.get(`${APIS.BASE_URL}admin/research-categories/rcType`, {
            params: params
        });
        
        if (result?.data?.data && Array.isArray(result?.data?.data)) {
            return result?.data?.data?.map(item => ({
                label: item || '',
                value: item || ''
            }));
        }
        return [];
    } catch (error) {
        console.error('Error fetching rcType suggestions:', error);
        return [];
    }
};